import gameSet from '@/api/administrator/game-set'
import result from '@/api/administrator/game-set-result'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment()
    .add(1, 'Day')
    .format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to
      },
      attrubutes
    )
    return result.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return result.store(data)
  },
  update(context, { id, data }) {
    return result.update(id, data)
  },
  destroy(context, id) {
    return result.destroy(id)
  },
  getGameSet(context, attrubutes = {}) {
    let params = Object.assign(
      {
        include: 'game_setting',
        fields: {
          game_sets:
            'game_set_name,game_set_id,result_date,close_time,game_setting_id'
        },
        page: -1
      },
      attrubutes
    )

    return gameSet.get({
      params: params,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
